import React, { useEffect } from 'react';
import 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { eventBus } from '@atc/cai-event-bus';
import WalletManager, { WALLET_RESET_CONSUMER_ID_REQUEST, WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, WALLET_CREATE_ID_COMPLETED, WALLET_SET_ERROR_ALERT_REQUEST, WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE, debugWallet } from 'wallet-manager';

/**
 * @param paymentsDuck (required)
 */
function WalletManagerContainer(_ref) {
  let {
    env = 'staging',
    paymentsDuck,
    fetchers = {},
    isLeaseDisabled = false
  } = _ref;
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(state => state?.auth?.isLoggedIn);
  useEffect(() => {
    if (!isLoggedIn) {
      eventBus.emit(WALLET_RESET_CONSUMER_ID_REQUEST);
    }
  }, [isLoggedIn]);
  function handleEnsurePaymentsInfo() {
    let {
      paymentInfo
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    debugWallet(`${WALLET_ENSURE_PAYMENTS_INFO_COMPLETED} - data received:`, paymentInfo);
    if (isLeaseDisabled && paymentInfo) {
      paymentInfo.dealType = 'finance';
      paymentInfo.paymentOption = 'finance';
      paymentInfo.downPaymentPercent = 0.2;
    }
    dispatch(paymentsDuck.creators.setPaymentsInfo(paymentInfo));
  }
  function handleUpdatePaymentsInfo(_ref2) {
    let {
      updated,
      updatedPayload
    } = _ref2;
    if (updated) {
      if (localStorage.getItem('WALLET_ID')) {
        const newUpdatedPayload = {
          ...updatedPayload,
          walletId: localStorage.getItem('WALLET_ID')
        };
        dispatch(paymentsDuck.creators.setPaymentsInfo(newUpdatedPayload));
      } else {
        dispatch(paymentsDuck.creators.setPaymentsInfo(updatedPayload));
      }
    }
  }
  function handleCreateWalletId() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (data.length > 0) {
      dispatch(paymentsDuck.creators.setWalletId(data));
    }
  }
  function handleShowWalletError(_ref3) {
    let {
      hasError
    } = _ref3;
    dispatch(paymentsDuck.creators.updateMyWallet({
      displayWalletErrorMessage: hasError
    }));
  }
  function handleCompareWalletDataComplete(_ref4) {
    let {
      paymentInfo,
      action = 'set'
    } = _ref4;
    if (action === 'update') {
      dispatch(paymentsDuck.creators.updatePaymentsInfo(paymentInfo));
    } else {
      dispatch(paymentsDuck.creators.setPaymentsInfo(paymentInfo));
    }
  }
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-new
      window.walletManager = window.walletManager || new WalletManager({
        environment: env,
        fetchers
      });
      eventBus.on(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleEnsurePaymentsInfo);

      // TODO: WALLET MANAGER: Is THIS the right place to handle updatePaymentsInfo?!
      eventBus.on(WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, handleUpdatePaymentsInfo);
      eventBus.on(WALLET_CREATE_ID_COMPLETED, handleCreateWalletId);
      eventBus.on(WALLET_SET_ERROR_ALERT_REQUEST, handleShowWalletError);
      eventBus.on(WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE, handleCompareWalletDataComplete);
      return () => {
        eventBus.off(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleEnsurePaymentsInfo);
        eventBus.off(WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, handleUpdatePaymentsInfo);
        eventBus.off(WALLET_CREATE_ID_COMPLETED, handleCreateWalletId);
        eventBus.off(WALLET_SET_ERROR_ALERT_REQUEST, handleShowWalletError);
        eventBus.off(WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE, handleCompareWalletDataComplete);
      };
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
var WalletManagerContainer$1 = /*#__PURE__*/React.memo(WalletManagerContainer);
export { WalletManagerContainer$1 as default };
